import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";

import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { FaFileExcel } from "react-icons/fa";

const ProfitLossReport = () => {
  const [stockData, setStockData] = useState([]);
  const [search, setSearch] = useState("");
const [fromDate, setFromDate] = useState("");
const [toDate, setToDate] = useState("");
  const client_id = localStorage.getItem("client_id");

  useEffect(() => {
    if (client_id) {
      fetchStock();
    } else {
      console.error("Client ID not found in localStorage");
    }
  }, [client_id]);

  const fetchStock = async () => {
    try {
      console.log("Fetching inventory for:", client_id);

      const res = await axios.get(
        `https://api.dectwinbilling.com/fetch-inventory/${client_id}`
      );

      setStockData(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error(err);

      if (err.response) {
        console.log("Status:", err.response.status);
        console.log("Message:", err.response.data);
      }

      setStockData([]);
    }
  };



<div className="d-flex justify-content-between align-items-center flex-wrap mb-3">

  <div className="d-flex align-items-center gap-3 flex-wrap">

    <div className="d-flex align-items-center">
      <label className="fw-bold me-2">From :</label>
      <input
        type="date"
        className="form-control"
        value={fromDate}
        onChange={(e) => setFromDate(e.target.value)}
      />
    </div>

    <div className="d-flex align-items-center">
      <label className="fw-bold me-2">To :</label>
      <input
        type="date"
        className="form-control"
        value={toDate}
        onChange={(e) => setToDate(e.target.value)}
      />
    </div>

  </div>

</div>




const filteredData = useMemo(() => {
  return stockData.filter((item) => {
    const searchText = search.toLowerCase();

    const matchesSearch =
      (item.name || "").toLowerCase().includes(searchText) ||
      String(item.barcode || "").includes(searchText);

    const itemDate = item.date
      ? new Date(item.date).toISOString().split("T")[0]
      : "";

    const matchesDate =
      (!fromDate || itemDate >= fromDate) &&
      (!toDate || itemDate <= toDate);

    return matchesSearch && matchesDate;
  });
}, [stockData, search, fromDate, toDate]);
  const totalStock = filteredData.reduce(
  (sum, item) => sum + Number(item.stock || 0),
  0
);

const totalSold = filteredData.reduce(
  (sum, item) => sum + Number(item.sold || 0),
  0
);
const unit = filteredData.reduce(
  (sum, item) =>
    sum +
    (Number(item.sale_price || 0) -
      Number(item.pur_price || 0)) -
      Number(item.discount|| 0),
  0
);

const totalProfit = filteredData.reduce(
  (sum, item) =>
    sum +
    (
      Number(item.sale_price || 0) -
      Number(item.pur_price || 0) -
      Number(item.discount || 0)
    ) * Number(item.sold || 0),
  0
);

const totalPP = filteredData.reduce(
  (sum, item) => sum + Number(item.pur_price || 0),
  0
);

const totalSP = filteredData.reduce(
  (sum, item) => sum + Number(item.sale_price || 0),
  0
);

return (
  <div className="container-fluid mt-3">

  
<div className="row mb-3">

  <div className="col-6 col-md-6">
    <label className="form-label fw-bold">From Date</label>
    <input
      type="date"
      className="form-control w-100 w-md-50"
      style={{ maxWidth: "220px" }}
      value={fromDate}
      onChange={(e) => setFromDate(e.target.value)}
    />
  </div>

  <div className="col-6 col-md-6 d-flex flex-column align-items-md-end">
    <label className="form-label fw-bold">To Date</label>
    <input
      type="date"
      className="form-control w-100"
      style={{ maxWidth: "220px" }}
      value={toDate}
      onChange={(e) => setToDate(e.target.value)}
    />
  </div>

</div>
    

    <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">

      <h3 className="fw-bold">Profit Loss Report</h3>

      {/* <input
        type="text"
        className="form-control"
        style={{ width: "280px" }}
        placeholder="Search by Name or Barcode"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      /> */}

      {/* <div className="fw-bold">
        Total PP : ₹{totalPP.toFixed(2)}
      </div>

      <div className="fw-bold">
        Total SP : ₹{totalSP.toFixed(2)}
      </div> */}

    </div>

<div
  className="table-responsive shadow-sm"
  style={{
    borderRadius: "15px",
    overflowX: "auto",
    overflowY: "auto",
    maxHeight: "550px",
    border: "1px solid #dee2e6",
    WebkitOverflowScrolling: "touch",
  }}
>

      <table className="table table-hover align-middle text-center mb-0">
          <thead className="table-primary">
            <tr>
              <th>Date</th>
              <th>sp(sales)</th>
              <th>sp(sale Return)</th>
              <th>pp(sale)</th>
              <th>pp(sale Return)</th>
              <th>Gross profit</th>
              <th>Expenses</th>
               <th>Net profit</th>
            </tr>
          </thead>

       <tbody>
  {filteredData.length ? (
    filteredData.map((item) => (
      <tr key={item.id}>
        <td className="fw-semibold">{item.name}</td>

        <td>
          <span >
            {item.barcode}
          </span>
        </td>

        <td>
          {item.date
            ? new Date(item.date).toLocaleDateString()
            : "-"}
        </td>

        <td>
          <span >
            {item.stock}
          </span>
        </td>

        <td>
          <span className="text-dark">
            {item.sold}
          </span>
        </td>

        <td className="fw-bold,text-secondary">
          ₹{Number(item.pur_price || 0).toFixed(2)}
        </td>

        <td className="fw-bold,text-secondary">
          ₹{Number(item.sale_price || 0).toFixed(2)}
        </td>

        <td>
          ₹{Number(item.discount || 0).toFixed(2)}
        </td>

        {/* <td className="text-dark fw-bold">
          ₹
          {(
            Number(item.sale_price || 0) -
            Number(item.pur_price || 0) -
            Number(item.discount || 0)
          ).toFixed(2)}
        </td> */}

        {/* <td className="text-success fw-bold fs-6">
          ₹
          {(
            (
              Number(item.sale_price || 0) -
              Number(item.pur_price || 0) -
              Number(item.discount || 0)
            ) * Number(item.sold || 0)
          ).toFixed(2)}
        </td> */}
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="10" className="py-5 text-muted">
        No Inventory Found
      </td>
    </tr>
  )}
</tbody>

        </table>

      </div>

<div className="d-flex justify-content-end mt-3">
  <button
    className="btn d-flex align-items-center gap-2 px-4 py-2 shadow"
    // onClick={exportToExcel}
    style={{
      background: "linear-gradient(135deg, #28a745, #198754)",
      color: "#fff",
      border: "none",
      borderRadius: "10px",
      fontWeight: "600",
      transition: "0.3s ease",
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = "scale(1.05)";
      e.currentTarget.style.boxShadow = "0 8px 20px rgba(25,135,84,0.35)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = "scale(1)";
      e.currentTarget.style.boxShadow = "";
    }}
  >
    <FaFileExcel size={20} />
     Excel
  </button>
</div>

    </div>
  );
};

export default ProfitLossReport;